import React, { useEffect, useState } from "react";
import { Thumbnail } from "./thumbnail";
import { useFunctions } from "./useFunctions";
export var System = function () {
    var BASEURL = "";
    var TOTALSTEP = 12;
    var _a = useState(false), isStart = _a[0], setIsStart = _a[1];
    var _b = useState(false), isEnd = _b[0], setIsEnd = _b[1];
    var _c = useState(0), stepIndex = _c[0], setStepIndex = _c[1];
    var _d = useState([
        {
            category: "japanese-modern",
            score: 0,
            title: "和モダン",
            description: "優しい木の風合いとかわいらしい小物で作り上げる落ち着きの空間",
            imageUrl: BASEURL +
                "/wp-content/themes/main-theme/img/like-system/japanese-modern.png",
            buttonUrl: BASEURL + "/japanese-modern",
        },
        {
            category: "natural",
            score: 0,
            title: "ナチュラル",
            description: "優しい木の風合いとかわいらしい小物で作り上げる落ち着きの空間",
            imageUrl: BASEURL + "/wp-content/themes/main-theme/img/like-system/natural.png",
            buttonUrl: BASEURL + "/natural",
        },
        {
            category: "chic",
            score: 0,
            title: "シック",
            description: "優しい木の風合いとかわいらしい小物で作り上げる落ち着きの空間",
            imageUrl: BASEURL + "/wp-content/themes/main-theme/img/like-system/chic.png",
            buttonUrl: BASEURL + "/chic",
        },
        {
            category: "nordic",
            score: 0,
            title: "北欧",
            description: "優しい木の風合いとかわいらしい小物で作り上げる落ち着きの空間",
            imageUrl: BASEURL + "/wp-content/themes/main-theme/img/like-system/nordic.png",
            buttonUrl: BASEURL + "/nordic",
        },
        {
            category: "vintage",
            score: 0,
            title: "ヴィンテージ",
            description: "優しい木の風合いとかわいらしい小物で作り上げる落ち着きの空間",
            imageUrl: BASEURL + "/wp-content/themes/main-theme/img/like-system/vintage.png",
            buttonUrl: BASEURL + "/vintage",
        },
    ]), patterns = _d[0], setPatterns = _d[1];
    var _e = useFunctions({
        setStepIndex: setStepIndex,
        patterns: patterns,
        setPatterns: setPatterns,
    }), plusStep = _e.plusStep, updateScore = _e.updateScore;
    var _f = useState(null), question = _f[0], setQuestion = _f[1], _g = useState(null), title = _g[0], setTitle = _g[1], _h = useState(null), description = _h[0], setDescription = _h[1], _j = useState(null), imageUrl = _j[0], setImageUrl = _j[1], _k = useState(null), buttonUrl = _k[0], setButtonUrl = _k[1];
    useEffect(function () {
        switch (stepIndex) {
            case 1:
                setQuestion("どのダイニングテーブルがコノミ？");
                break;
            case 2:
                setQuestion("どのソファーがコノミ？");
                break;
            case 3:
                setQuestion("どのダイニングチェアがコノミ？");
                break;
            case 4:
                setQuestion("どのテレビボードがコノミ？");
                break;
            case 5:
                setQuestion("どの照明がコノミ？");
                break;
            case 6:
                setQuestion("どのダイニングチェアがコノミ？");
                break;
            case 7:
                setQuestion("どのソファーがコノミ？");
                break;
            case 8:
                setQuestion("どの照明がコノミ？");
                break;
            case 9:
                setQuestion("どのクロスがコノミ？");
                break;
            case 10:
                setQuestion("どの壁・クロスがコノミ？");
                break;
            case 11:
                setQuestion("どのフローリングがコノミ？");
                break;
            case TOTALSTEP:
                handleComplete();
                setIsEnd(true);
                break;
            default:
                break;
        }
    }, [stepIndex]);
    function handleComplete() {
        var lastScore = patterns.map(function (p) {
            return p.score;
        });
        var result = patterns.find(function (item) { return item.score === Math.max.apply(null, lastScore); });
        setTitle(result.title);
        setDescription(result.description);
        setImageUrl(result.imageUrl);
        setButtonUrl(result.buttonUrl);
    }
    function handleReset() {
        setIsEnd(false);
        setIsStart(false);
        setStepIndex(1);
        setPatterns(function (prevState) {
            return prevState.map(function (obj) {
                return true
                    ? {
                        category: obj.category,
                        score: 0,
                        title: obj.title,
                        description: obj.description,
                        imageUrl: obj.imageUrl,
                        buttonUrl: obj.buttonUrl,
                    }
                    : obj;
            });
        });
    }
    return (<>
      {isStart ? (<>
          {isEnd ? (<>
              <div className="p-likesystem__header p-likesystem__header--sub">
                <a href={"".concat(BASEURL)}>
                  <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/common/logo.png")} alt="デザイン×リフォーム専門店 リビングLABO"/>
                </a>
                <h1>デザイン診断</h1>
              </div>
              <div className="p-likesystem__body">
                <div className="p-likesystem__body__row">
                  <div className="p-likesystem__body__col">
                    <img src={imageUrl} alt={title}/>
                  </div>
                  <div className="p-likesystem__body__col">
                    <h2 className="p-likesystem__body__title">{title}</h2>
                    <p className="p-likesystem__body__description">
                      {description}
                    </p>
                    <a href={buttonUrl} className="p-likesystem__body__button--gray">
                      {title}の説明を見る
                    </a>
                    <p className="p-likesystem__body__score-title">
                      あなたの選んだデザイン家具
                    </p>
                    <div className="p-likesystem__body__score">
                      {patterns.map(function (elem, index) {
                    return (<dl className="p-likesystem__body__score__child">
                            <dt>
                              <span>{elem.title}</span>
                            </dt>
                            <dd>
                              <span>{elem.score}点</span>
                            </dd>
                          </dl>);
                })}
                    </div>
                  </div>
                </div>
                <p className="p-likesystem__body__center">
                  <button className="p-likesystem__body__button" onClick={function () {
                    handleReset();
                }}>
                    <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/common/cv_design.svg")} alt="*"/>
                    もう一度診断する
                  </button>
                </p>
              </div>
            </>) : (<div className="p-likesystem__question">
              <div className="p-likesystem__header p-likesystem__header--sub">
                <a href={"".concat(BASEURL)}>
                  <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/common/logo.png")} alt="デザイン×リフォーム専門店 リビングLABO"/>
                </a>
                <h1>デザイン診断</h1>
              </div>
              <div className="p-likesystem__body">
                <p className="p-likesystem__body__center">{question}</p>
                <div className="p-likesystem__body__row">
                  {patterns.map(function (e, i) {
                    return (<Thumbnail key={i} stepIndex={stepIndex} id={i} category={e.category} patterns={patterns} plusStep={plusStep} updateScore={updateScore}/>);
                })}
                </div>
              </div>
            </div>)}
        </>) : (<>
          <div className="p-likesystem__header">
            <a href={"".concat(BASEURL)}>
              <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/common/logo.png")} alt="デザイン×リフォーム専門店 リビングLABO"/>
            </a>
          </div>
          <div className="p-likesystem__hero">
            <h1>デザイン診断</h1>
          </div>
          <div className="p-likesystem__body">
            <div className="p-likesystem__body__center">
              <p>
                あなたのコノミのデザインを
                <br className="sp-only"/>
                見つけることができます！
              </p>
              <div className="p-likesystem__body__button" onClick={function () {
                setStepIndex(1);
                setIsStart(true);
            }}>
                <img src={"".concat(BASEURL, "/wp-content/themes/main-theme/img/common/cv_design.svg")} alt="*"/>
                デザイン診断をはじめる
              </div>
            </div>
          </div>
        </>)}
    </>);
};
